'use strict';

var RecapPaxGapAggregationFactory = function RecapPaxGapAggregationFactory(DataAggregationFactory) {
  function RecapPaxGapAggregation() {
    DataAggregationFactory.call(this, 'rom-analysis-flattened-services-mode', 'recap-pax-gap');
  }
  RecapPaxGapAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  RecapPaxGapAggregation.constructor = RecapPaxGapAggregation;
  RecapPaxGapAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  RecapPaxGapAggregation.prototype.aggregate = function (data, metricsKeys) {
    var aggregatedRecapPaxGap = [],
      map = [];
    var self = this;
    for (var i = 0; i < data.length; i++) {
      var record = data[i];
      var service = record.service;
      var mapServiceIndex = map.indexOf(service);
      var dow = record.dow;
      var recapPaxGap = {};
      if (mapServiceIndex === -1) {
        recapPaxGap[dow] = self.getMetricValue(record.recapPaxGap, metricsKeys, true);
        recapPaxGap.potentialRevenue = self.getMetricValue(record.potentialRevenue, metricsKeys, true);
        recapPaxGap.service = service;
        aggregatedRecapPaxGap.push(recapPaxGap);
        map.push(service);
      } else if (!aggregatedRecapPaxGap[mapServiceIndex][dow]) {
        aggregatedRecapPaxGap[mapServiceIndex][dow] = self.getMetricValue(record.recapPaxGap, metricsKeys, true);
        aggregatedRecapPaxGap[mapServiceIndex].potentialRevenue += self.getMetricValue(record.potentialRevenue, metricsKeys, true);
      } else {
        aggregatedRecapPaxGap[mapServiceIndex][dow] += self.getMetricValue(record.recapPaxGap, metricsKeys, true);
        aggregatedRecapPaxGap[mapServiceIndex].potentialRevenue += self.getMetricValue(record.potentialRevenue, metricsKeys, true);
      }
    }
    return self.sortBy(aggregatedRecapPaxGap, 'potentialRevenue', 'DESC');
  };
  return RecapPaxGapAggregation;
};
RecapPaxGapAggregationFactory.$inject = ['AbstractROMServiceAggregationFactory'];
module.exports = RecapPaxGapAggregationFactory;